export const API_URL =
  process.env.NEXT_PUBLIC_API_URL ?? "https://admin.sip24seven.com/api/portal";
export const IMAGE_BASE_URL =
  process.env.NEXT_PUBLIC_IMAGE_BASE_URL ??
  "https://admin.sip24seven.com/api/files";
